
import React, { useState, useEffect, Fragment, useMemo } from 'react'

import { useTeams } from '@/Hooks/UseTeam'
import useTranslation from '@/Hooks/UseTranslation'
import UserAvatar from '@/Components/UserAvatar/UserAvatar'
import OptionsDialog from '@/Components/OptionsDialog/OptionsDialog'
import { useAuth } from '@/Hooks/UseAuth'
import { Can } from '@/Casl/Casl'
import Swal from 'sweetalert2'

const PendingInvites = () => {

  const { t } = useTranslation()

  const { ability } = useAuth()

  const { teamSelected, cancelInvite, resendInvite } = useTeams()

  const [invite, setInvite] = useState<any>(undefined)
  const [showInviteOptions, setShowInviteOptions] = useState(false)

  const options = useMemo(() => {

    const options: any[] = []

    if (!invite) return options

    if (ability.can('resend', 'Invitation')) {

      options.push({
        icon: <span className="icon-notificaciones"></span>,
        label: t('TEAMS:ContextMenuResendInvitationOption'),
        onClick: () => handleResendInvite(invite._id)
      })
    }

    if (ability.can('cancel', 'Invitation')) {

      options.push({
        icon: <span className="icon-cancelar" />,
        color: 'var(--color-danger)',
        label: t('TEAMS:ContextMenuCancelInvitationOption'),
        onClick: () => cancelInvite(invite._id)
      })
    }

    return options
  }, [ invite, showInviteOptions ])

  const handleShowInviteOptions = (user: any) => {

    setInvite(user)
    setShowInviteOptions(true)
  }

  const handleResendInvite = async (user_id: string) => {

    await resendInvite(user_id)

    Swal.fire({
      title: t('TEAMS:InviteSentTitle'),
      text: t('TEAMS:InviteSentContent'),
      icon: 'success',
      confirmButtonText: t('TEAMS:InviteSentConfirmButton'),
      width: '500px'
    })
  }

  if (!teamSelected.invites || teamSelected.invites.length === 0) return null

  return (
    <Fragment>
      <div className='members-section'>
        <h5>{t('TEAMS:PendingInvitesTitle')}</h5>
        <div className="members-content-list">
          {teamSelected.invites.map((invite: any, i: number) => (
            <div key={`${i}-${invite._id}`} className="members-content-item">
              <UserAvatar user={invite} />
              <div className="member-texts">
                <div className='member-name'>
                  {invite.name} {invite.surname}
                </div>
                <div className='member-email'>
                  {invite.email}
                </div>
              </div>
              <div className="member-profile">
                <span className="profile-badge">
                  {t('TEAMMEMBER_SELECTOR:Pending')}
                </span>
              </div>
              <div className="member-actions">
                <Can I="manage" a="all" ability={ability}>
                  <button
                    className="btn btn-light mr-1"
                    onClick={() => handleShowInviteOptions(invite)}
                  >
                    <i className="fas fa-fw fa-ellipsis-v"></i>
                  </button>
                </Can>
              </div>
            </div>
          ))}
        </div>
      </div>

      <OptionsDialog
        show={showInviteOptions}
        title={`${invite?.name} ${invite?.surname}`}
        closeButton
        onHide={() => {

          setShowInviteOptions(false)
        }}
        options={options}
      />

    </Fragment>
  )
}

export default PendingInvites
